import {O} from "web-vcore";
import {StatView} from "../../Server/DB/statViews/@StatView.js";

export class StatsState {
	@O accessor subpage = "stats";

	@O accessor view = new StatView();
	@O accessor lastAppliedViewID: string|n;
	@O accessor viewLocks = new StatViewLocks();
}

/** View-lock field-values, get applied "on top of" the selected view, at the time the view becomes selected. (ie. "locking" it to that value) */
export class StatViewLocks {
	@O accessor days_omitLastX: number|n;
}